import { Card, CardContent, LinearProgress } from "@material-ui/core";
import React, { Component } from "react";
import { Spinner, Table } from "react-bootstrap";
import SVG from "react-inlinesvg";
// import { Bar } from 'react-chartjs-2';
import { Doughnut, Pie } from "react-chartjs-2";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Moment from "react-moment";
import { forEach } from "lodash";
const bgImage = toAbsoluteUrl("/media/bg/bg-5.jpg");
class Info1 extends Component {
  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
  };

  render() {
    let display = [];
    console.log("PROPS =", this.props);
    console.log("Total Dosen =", this.props.dataProfile.data);
    if (this.props.displayData === false) {
      let data = this.props.dataProfile.data.profile;
      let jumdosen = this.props.dataProfile.data.jumdosen;
      let last_key_jumdosen =
        jumdosen[Object.keys(jumdosen)[Object.keys(jumdosen).length - 1]];
      let totaldosen = last_key_jumdosen.toString();
      let akreditasi_pt = [];
      if (data.akred_sp.nm_akred === "A") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      } else if (data.akred_sp.nm_akred === "B") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      } else if (data.akred_sp.nm_akred === "C") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      } else if (data.akred_sp.nm_akred === "Unggul") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      } else if (data.akred_sp.nm_akred === "Baik Sekali") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      } else if (data.akred_sp.nm_akred === "Baik") {
        akreditasi_pt = (
          <>
            {data.akred_sp.nm_akred}
            &nbsp;(
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />
            <span className="fa fa-star" style={{ color: "#FFD700" }} />) -
            Berlaku sampai{" "}
            <Moment
              date={data.akred_sp.tgl_sampai_berlaku}
              format="DD MMMM YYYY"
            />
          </>
        );
      }

      // console.log("DATA =", data)
      let Logo = this.props.dataProfile.data.logo;

      console.log(data.akred_prodi);

      let label_nasional = [];
      let jum_nasional = [];
      let color_nasional = [];
      let key1 = 0;
      data.akred_prodi.nasional.forEach((e) => {
        label_nasional[key1] = e.akred_prodi !== "null" ? e.akred_prodi : "-";
        jum_nasional[key1] = e.jum !== "null" ? e.jum : 0;
        if (e.akred_prodi === "null") {
          color_nasional[key1] = "rgb(102, 204, 255)";
        } else if (e.akred_prodi === "A") {
          color_nasional[key1] = "rgb(26, 188, 156)";
        } else if (e.akred_prodi === "B") {
          color_nasional[key1] = "rgb(255, 228, 0)";
        } else if (e.akred_prodi === "Baik") {
          color_nasional[key1] = "rgb(255, 195, 0)";
        } else if (e.akred_prodi === "Baik Sekali") {
          color_nasional[key1] = "rgb(255, 150, 0)";
        } else if (e.akred_prodi === "C") {
          color_nasional[key1] = "rgb(255, 89, 0)";
        } else if (e.akred_prodi === "Unggul") {
          color_nasional[key1] = "rgb(46, 134, 193)";
        } else {
          color_nasional[key1] = "rgb(102, 204, 255)";
        }
        key1++;
      });

      let label_internasional = [];
      let jum_internasional = [];
      let color_internasional = [];
      let key2 = 0;
      data.akred_prodi.internasional.forEach((e) => {
        label_internasional[key2] =
          e.akred_prodi !== "null" ? e.akred_prodi : "-";
        jum_internasional[key2] = e.jum !== "null" ? e.jum : 0;
        if (e.akred_prodi === "Unggul") {
          color_internasional[key2] = "rgb(46, 134, 193)";
        } else {
          color_internasional[key2] = "rgb(102, 204, 255)";
        }
        key2++;
      });

      console.log(color_internasional);

      let DataNasional = {
        labels: label_nasional,
        datasets: [
          {
            data: jum_nasional,
            backgroundColor: color_nasional,
            borderWidth: 1,
          },
        ],

        text: "",
      };

      let DataInternasional = {
        labels: label_internasional,
        datasets: [
          {
            data: jum_internasional,
            backgroundColor: color_internasional,
            borderWidth: 1,
          },
        ],

        text: "",
      };

      let akreditasi_nasional = <></>;
      if (data.akred_prodi.nasional.length > 0) {
        akreditasi_nasional = (
          <div className="col-md-6 text-grey text-center mt-5">
            Akreditasi Program Studi
            <Pie data={DataNasional} height={200} />
          </div>
        );
      }

      let akreditasi_internasional = <></>;
      if (data.akred_prodi.internasional.length > 0) {
        akreditasi_internasional = (
          <div className="col-md-6 text-grey text-center mt-5">
            Akreditasi Internasional
            <Pie data={DataInternasional} height={200} />
          </div>
        );
      }

      display = (
        <>
          <div className="col-md-5">
            <div>
              <Table responsive className="table-borderless text-white">
                <tbody>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "left" }}>
                        {
                          (Logo !== "") ?
                          <div
                            className="bg-white"
                            style={{
                              width: "50%",
                              padding: "10%",
                              borderRadius: "50%",
                            }}
                          >
                            <img
                              style={{ width: "" }}
                              className="img-fluid"
                              src={`data:image/jpeg;base64,${Logo}`}
                            />
                            </div>
                          :
                          <div
                            className="bg-white"
                            style={{
                              width: "210px",
                              padding: "5px",
                              borderRadius: "50%",
                            }}
                          >
                          <img
                            src="/media/logos/noimage.jpeg"
                            alt="SPMI logo"
                            style={{
                              width: "200px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        }
                        
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <h4 style={{ marginTop: "6%" }} className="text-white">
                        {data.nm_lemb}
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Kode PT</td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>{data.npsn}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Nomor SK PT</td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>
                      {data.sk_pendirian_sp}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Tanggal SK PT</td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>
                      <Moment
                        date={data.tgl_sk_pendirian_sp}
                        format="DD MMMM YYYY"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Tanggal Berdiri</td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>
                      <Moment date={data.tgl_berdiri} format="DD MMMM YYYY" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Jumlah Dosen</td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td>{totaldosen}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>
                      Jumlah Tenaga Kependidikan
                    </td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>
                      {data.totaltendik.jum}
                    </td>
                  </tr>
                  {/* <tr>
                    <td style={{ verticalAlign: "middle" }}>
                      Dosen yang siap sebagai auditor spmi
                    </td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>-</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>
                      Ketersediaan anggaran pt
                    </td>
                    <td style={{ verticalAlign: "middle" }}>:</td>
                    <td style={{ verticalAlign: "middle" }}>-</td>
                  </tr> */}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="col-md-7">
            <Card>
              <CardContent>
                <Table responsive className="table-borderless">
                  <tbody>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Akreditasi
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>
                        {akreditasi_pt}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Status PT
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>Aktif</td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Kode Pos
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>
                        {data.kode_pos}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Telepon
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>{data.no_tel}</td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Faximile
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>{data.no_fax}</td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle" }}
                        className="text-success font-weight-bold font-size-1"
                      >
                        Email
                      </td>
                      <td style={{ verticalAlign: "middle" }}>:</td>
                      <td style={{ verticalAlign: "middle" }}>{data.email}</td>
                    </tr>
                  </tbody>
                </Table>
                <div className="row row-paddingless mt-5">
                  <div className="col-md-12 text-center h4 mb-5">
                    Statistik Akreditasi Yang Didapat
                  </div>
                  {akreditasi_nasional}
                  {akreditasi_internasional}
                </div>
              </CardContent>
            </Card>
          </div>
        </>
      );
    } else {
      display = (
        <>
          <div className="col-md-12 text-white">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Loading ..
            <LinearProgress color="secondary" variant="query" />
          </div>
        </>
      );
    }
    return (
      <>
        <Card>
          <div style={{ backgroundImage: `url(${bgImage})` }}>
            <div className="row row-paddingless" style={{ padding: "5%" }}>
              {display}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
export default Info1;
